import React from "react";
import useDesignSystemStore from "@/store/zustand/aiDesignSystemBuilder";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";
import { X } from "lucide-react";

const ExamplesViewer = () => {
  const examples = useDesignSystemStore(
    (state) => state.generation.context.examples
  );

  const removeExample = useDesignSystemStore((state) => state.removeExample);

  return (
    <Accordion type="single" collapsible className="w-full">
      {examples.map((example, index) => (
        <AccordionItem key={index} value={`item-${index}`}>
          <AccordionTrigger className="text-3xs py-2 font-bold text-secondary-800 items-center group">
            <div className="flex flex-row gap-1 items-center">
              <span>Snippet {index + 1}</span>
              <X
                className="h-3 w-3 hidden group-hover:block cursor-pointer hover:text-white"
                onClick={() => removeExample(index)}
              />
            </div>
          </AccordionTrigger>
          <AccordionContent className="py-2">
            <pre className="flex flex-col gap-4 max-h-[200px] overflow-y-auto p-4 border rounded-md border-secondary-300 font-mono text-3xs">
              {example}
            </pre>
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
};

export default React.memo(ExamplesViewer);
